import Vue from "vue";
import Component from 'vue-class-component';
import { modalHelper, IModalBase, DataItem, alertHelper } from '@/components';
import { Deferred } from '@/utils/Deferred';
import { areaRaccoltaStore } from '../store/areaRaccolta.store';
import { Prop } from 'vue-property-decorator';
import map from "./map.vue";
import { Async } from '@/utils/AsyncDecorators';
import { areaBoscoDaSemeStore } from '@/modules/AreeBoscoDaSeme/store/areaBoscoDaSeme.store';
import { localizeFunction } from '@/filters/localizeFilter';
import { toastHelper } from '@/helpers/ToastHelper';
import { geojsonType } from '@turf/turf';

@Component({})
export default class Form extends Vue implements IModalBase<server.areaRaccolta>{
  @Prop()
  value: server.areaRaccolta;

  @Prop()
  deferred: Deferred<DataItem<server.areaRaccolta>>;

  @Async({ async get() { return (await areaBoscoDaSemeStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: true })
  areeBoscoDaSeme: server.areaBoscoDaSeme[];

  mounted() {
    setTimeout(this.validateForm, 2000); 
  }
   
  formIsValid: boolean = false;
  validateForm() {
    this.formIsValid = (this.$refs.form && (this.$refs.form as any).checkValidity())
  }

  cancel() {
    modalHelper.Unchanged(this);
    modalHelper.closeModal("extended");
  }

  saving: boolean = false;
  async ok()
  {
    if (this.saving) return;

    this.saving = true;
    await areaRaccoltaStore.actions.setAreaRaccolta(this.value);
    await (this.$refs.slideShow as any).save(this.value.id);
    modalHelper.Changed(this);
  }

  async remove()
  {
    if (await alertHelper.show(localizeFunction('confirm-delete', `Sei sicuro di voler cancellare l'elemento corrente?`)))
    {
      try{
        await areaRaccoltaStore.actions.remove(this.value);
        modalHelper.Deleted(this);
      }catch(e){
        if(e && e.response && e.response.status==412) toastHelper.error('Impossibile cancellare elemento, sono presenti uno o più vincoli che ne impediscono la cancellazione.')
        modalHelper.Unchanged(this);
      }

    }else{
      modalHelper.Unchanged(this);
    }
  }


  async editGeometry()
  {
    const result: DataItem<server.areaRaccolta> = await modalHelper.showModal<server.areaRaccolta>(map, Object.assign({}, this.value), "extended");
    if (result.status && result.item.geoJSON)
    {
      this.value.geoJSON = result.item.geoJSON;
      this.value.area = result.item.area;
    }
  }

  async geoJsonUploaderChange(geoJSON: string){
    this.value.geoJSON = geoJSON;
    this.editGeometry();
  }
}